import { TranslationContext } from '@core/i18n'

import { useLiveHelperTranslation } from './useLiveHelperTranslation'

/**
 * Provides the Agent component with the appropriate context translation
 * function so child components can `useContextTranslation`.
 */
export const LiveHelperTranslationProvider: React.FC<
  React.PropsWithChildren
> = ({ children }) => {
  const liveHelperTranslationFn = useLiveHelperTranslation()

  return (
    <TranslationContext.Provider value={liveHelperTranslationFn}>
      {children}
    </TranslationContext.Provider>
  )
}
